module.exports = __webpack_public_path__ + "static/media/step-selfie-inactive.580153a8.svg";